import { Card, CardContent, Stack } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import { NoDataPanel } from 'components/card/NoDataCard'
import Input from 'components/forms/Input'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import Textarea from 'components/forms/Textarea'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import DtoCasingDeclaration from 'survey/dto/DtoCasingDeclaration'

const OuvrageCard = ({
    title,
    ouvrage,
    actions,
}) => (
    <Card sx={{ border: '1px solid', borderColor: 'primary.main', borderRadius: 2 }} >
        <CardTitle title={title} actions={actions} color='primary' />
        <CardContent>
            {ouvrage ? (
                <Stack>
                    <Input
                        title={i18n.depth}
                        value={ouvrage.depth}
                        readMode
                    />
                    <SimpleDatePicker
                        label={i18n.completionDate}
                        value={ouvrage.completionDate}
                        readMode
                    />
                    <SimpleDatePicker
                        label={i18n.declarationDate}
                        value={ouvrage.declarationDate}
                        readMode
                    />
                    <Input
                        title={i18n.receiptNumber}
                        value={ouvrage.receiptNumber}
                        readMode
                    />
                    <SimpleDatePicker
                        label={i18n.receiptDate}
                        value={ouvrage.receiptDate}
                        readMode
                    />
                    <Input
                        title={i18n.cementing}
                        value={ouvrage.cementing ? i18n.yes : i18n.no}
                        readMode
                    />
                    <Input
                        title={i18n.concreteCoping}
                        value={ouvrage.concreteCoping ? i18n.yes : i18n.no}
                        readMode
                    />
                    <Input
                        title={i18n.protectionHead}
                        value={ouvrage.protectionHead ? i18n.yes : i18n.no}
                        readMode
                    />
                    <Input
                        title={i18n.copingHeight}
                        value={ouvrage.copingHeight}
                        readMode
                    />
                    <Input
                        title={i18n.reserveFlow}
                        value={ouvrage.reserveFlow}
                        readMode
                    />
                    <Textarea
                        title={i18n.comment}
                        value={ouvrage.comment}
                        readMode
                    />
                </Stack>
            ) : (
                <NoDataPanel />
            )}
        </CardContent>
    </Card>
)

OuvrageCard.propTypes = {
    title: PropTypes.string.isRequired,
    ouvrage: PropTypes.instanceOf(DtoCasingDeclaration).isRequired,
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element,
            ]),
            onClick: PropTypes.func,
            color: PropTypes.string,
            displayed: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
}

export default OuvrageCard
